module.exports = __webpack_public_path__ + "media/tip_tier_2-a59253f85b3f25fc5e2e0b568c9cc9ca.mp3";